import React, { useMemo } from 'react';

import { SITEMAP_TITLE_ATTRIBUTES } from 'utils/constant';

import SitemapLinksSection from '../sitemapLinksSection';

const MostCommonJobs = ({ mostCommonJobTitles }) => {
  const links = useMemo(() => {
    let data = [];

    mostCommonJobTitles.forEach((i) => {
      let item = {};
      item.mainTitle = i.jobTitle;
      item.mainLink = i.link;
      item.htmlTitle = SITEMAP_TITLE_ATTRIBUTES.MAIN_JOB_TITLE.format({ title: i.jobTitle, jobTitleArticle: i.jobTitleArticle }, true)
      item.subLinks = [];

      if (i.jobsPageLink) {
        let htmlTitle = SITEMAP_TITLE_ATTRIBUTES.JOBS.format({ title: i.jobTitle }, true)
        item.subLinks.push({ title: 'Jobs', link: i.jobsPageLink, htmlTitle: htmlTitle });
      }
      if (i.salaryPageLink) {
        let htmlTitle = SITEMAP_TITLE_ATTRIBUTES.SALARY.format({ title: i.jobTitle }, true)
        item.subLinks.push({ title: 'Salary', link: i.salaryPageLink, htmlTitle: htmlTitle });
      }
      if (i.locationsPageLink) {
        let htmlTitle = SITEMAP_TITLE_ATTRIBUTES.LOCATIONS.format({ title: i.jobTitle }, true)
        item.subLinks.push({ title: 'Locations', link: i.locationsPageLink, htmlTitle: htmlTitle });
      }

      data.push(item);
    });

    return data;
  }, [mostCommonJobTitles]);

  return (
    <section className="section">
      <div className="container">
        <SitemapLinksSection
          title={<h2 className="brandonH2 sec-head pr-15">Most in demand jobs and salaries</h2>}
          links={links}
        />
      </div>
    </section>
  );
};

export default MostCommonJobs;
